module.exports = __webpack_public_path__ + "img/free-day-flying-icon.16e5a29a.svg";